import { render, staticRenderFns } from "./Matrizes.vue?vue&type=template&id=5b7335b0&scoped=true&"
import script from "./Matrizes.vue?vue&type=script&lang=js&"
export * from "./Matrizes.vue?vue&type=script&lang=js&"
import style0 from "./Matrizes.vue?vue&type=style&index=0&id=5b7335b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7335b0",
  null
  
)

component.options.__file = "Matrizes.vue"
export default component.exports